export default __webpack_public_path__ + "static/ux-ui-boost-redesign-f473f4d0be968ceedb354ac005b6e3ae.pdf";